var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@app/Components/Grid/Grid';
import { Column, FilterRow, HeaderFilter, Scrolling, SearchPanel } from 'devextreme-react/data-grid';
import { FiUserCheck, FiUserX } from 'react-icons/fi';
export var UserCountersTable = /** @class */ (function (_super) {
    __extends(UserCountersTable, _super);
    function UserCountersTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserCountersTable.prototype.render = function () {
        var data = this.props.data;
        return (React.createElement(Grid, { dataSource: data },
            React.createElement(Column, { dataField: "serverName", groupIndex: 0, caption: "Server Name", autoExpandGroup: true }),
            React.createElement(Column, { dataField: "userName", caption: "User Name", width: 260 }),
            React.createElement(Column, { dataField: "isOnline", caption: "Is Online", width: 260, allowSearch: false, allowFiltering: false, cellRender: function (_a) {
                    var data = _a.data;
                    return data.isOnline ? React.createElement(FiUserCheck, { color: "green" }) : React.createElement(FiUserX, { color: "gray" });
                } }),
            React.createElement(Column, { dataField: "isUniqueConnected", caption: "Is Unique Connected", width: 180, allowSearch: false, allowFiltering: false, allowHeaderFiltering: true, calculateCellValue: function (data) {
                    return data.isUniqueConnected ? 'Yes' : 'No';
                } }),
            React.createElement(Column, { dataField: "requestsCount", caption: "Request Count", headerFilter: { groupInterval: 50 }, width: 200 }),
            React.createElement(Column, { dataField: "", caption: "", allowSorting: false }),
            React.createElement(HeaderFilter, { visible: true }),
            React.createElement(SearchPanel, { visible: true }),
            React.createElement(FilterRow, { visible: true }),
            React.createElement(Scrolling, { mode: "virtual" })));
    };
    UserCountersTable = __decorate([
        observer
    ], UserCountersTable);
    return UserCountersTable;
}(React.PureComponent));
